import getBasePath from '../functions/api-resource';

const basePath = getBasePath('api', 'representante-logado');

const representanteLogadoActions = {
  clientes: { method: 'GET', url: `${basePath}/clientes?indAtivo=true&colunaOrdenacao=nom_cliente` },
};

export default (resource) => resource(`${basePath}`, {}, representanteLogadoActions);
